import { FetchArgs } from '@reduxjs/toolkit/query';
import { addApiKeyHeaders } from 'utils/helpers/path.helpers';

export async function buildArgsWithApiKey(
  requestArgs: string | FetchArgs,
  fallbackMethod = 'GET',
): Promise<FetchArgs> {
  const method =
    typeof requestArgs !== 'string' && requestArgs.method ? requestArgs.method : fallbackMethod;

  const headers =
    typeof requestArgs !== 'string'
      ? new Headers(requestArgs.headers as HeadersInit)
      : new Headers();

  await addApiKeyHeaders(headers, requestArgs, method);

  if (typeof requestArgs === 'string') {
    return {
      url: requestArgs,
      method,
      headers: Object.fromEntries(headers.entries()),
    };
  }

  return {
    ...requestArgs,
    headers: {
      ...(requestArgs.headers || {}),
      ...Object.fromEntries(headers.entries()),
    },
  };
}
